export default __webpack_public_path__ + "static/media/SB4.b514a98b.jpg";